import { createSlice } from "@reduxjs/toolkit";

export const lockersSlice = createSlice({
  name: "lockers",
  initialState: {
    searchLockerFilter: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      lockerTypeId: "-1",
    },
    searchLockerData: [],
    lockerTypeList: [],
  },
  reducers: {
    setSearchLockerFilter: (state, actions) => {},
    setSearchLockerData: (state, actions) => {
      state.searchLockerData = actions.payload;
    },
    getLockerTypeList: (state, actions) => {
      state.lockerTypeList = actions.payload;
    },
    handleOnChanged: (state, actions) => {
      const { name, value } = actions.payload;
      switch (name) {
        case "lockerTypeId":
          return {
            ...state,
            searchLockerFilter: {
              ...state.searchLockerFilter,
              lockerTypeId: value,
            },
          };
      }
    },
    clearData: (state) => {
      // state.lockerTypeList = [];
      state.searchLockerData = [];
      state.searchLockerFilter = {
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
        lockerTypeId: "-1",
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSearchLockerFilter,
  setSearchLockerData,
  getLockerTypeList,
  handleOnChanged,
  clearData,
} = lockersSlice.actions;

export default lockersSlice.reducer;
